import { createContext, useState, useEffect, useContext } from 'react'

import { AuthContext } from '../../../context/AuthContext'
import { SessionContext } from '../../../context/SessionContext'

import { checkDemographicSurvey } from '../service/demographicSurveyService'

export const DemographicSurveyContext = createContext()

export const DemographicSurveyProvider = ({ children }) => {
  const { currentUser } = useContext(AuthContext)
  const { session } = useContext(SessionContext)

  const [hasCompleted, setHasCompleted] = useState(null) // null = loading

  useEffect(() => {
    const fetchStatus = async () => {
      if (!currentUser?.id || !session?.id) return
      try {
        const result = await checkDemographicSurvey(currentUser.id, session.id)
        setHasCompleted(result?.completed ?? false)
      } catch (error) {
        console.error('Error checking demographic survey:', error)
        setHasCompleted(false)
      }
    }
    fetchStatus()
  }, [currentUser?.id, session?.id])

  const markCompleted = () => setHasCompleted(true)

  return (
    <DemographicSurveyContext.Provider value={{ hasCompleted, markCompleted }}>
      {children}
    </DemographicSurveyContext.Provider>
  )
}